import React, { useState } from "react";
import Button from "../../../components/Buttons/Button";
import getCookie from "../../../utils/getCookie";

const SelectCashGameCard = ({
  selected,
  onClick,
  topTitle,
  title,
  description,
  cardImg,
}) => {
  return (
    <div
      className={`select-cash-game-card flex w-[50%] flex-col items-center rounded-xl min-[320px]:h-[24rem] min-[375px]:h-[21rem] min-[600px]:h-80 min-[600px]:w-full ${selected ? "selected-cash-game-card" : ""
        }`}
      onClick={onClick}
    >
      <div className=" mt-2 text-center text-[11px] font-normal uppercase text-teal-400 min-[320px]:text-[9px]  min-[600px]:text-sm">
        {topTitle}{" "}
      </div>
      <div className="text-center text-[18px] font-bold capitalize text-neutral-100 min-[600px]:text-2xl">
        {title}
      </div>
      <div className="mt-4 flex">
        <img src={cardImg} alt="Cash Game Card" />
      </div>
      <div className="mt-4 h-32 w-full px-[8px] text-center text-[10px] font-normal leading-[11px] text-neutral-100 min-[500px]:text-[12px] min-[600px]:w-52 min-[600px]:px-0 min-[600px]:leading-[14px]">
        {description}
      </div>
    </div>
  );
};

export default function SelectCashGameModal({ show, setShow }) {
  const [cashGameSelected, setCashGameSelected] = useState("");

  const handleContinueBtn = () => {
    if (cashGameSelected["type"] === "regular") {
      window.location.href = cashGameSelected["url"];
    } else if (cashGameSelected["type"] === "quick") {
      let form = document.createElement("form");
      let csrfInput = document.createElement("input");
      form.method = "POST";
      form.action = cashGameSelected["url"];

      csrfInput.value = getCookie("csrftoken");
      csrfInput.name = "csrfmiddlewaretoken";
      form.appendChild(csrfInput);

      document.body.appendChild(form);
      form.submit();
    }
  };

  return (
    <div className="flex flex-col items-center w-full h-full px-[20px] min-[500px]:px-[50px] pt-[65px] min-[500px]:pt-[50px] container-limits justify-between">
      <div className="flex w-full flex-col max-w-[700px]">
        <div className="w-full text-white text-[16px] min-[500px]:text-[28px] font-semibold min-[500px]:font-bold pt-[10px] pb-[20px]">
          Create Cash Table
        </div>
        <div className="flex items-center text-[14px] font-normal text-white">
          Select what type of cash table you'd like to create:
        </div>
        <div className="flex flex-col w-full gap-8 mt-[30px]">

          <div className={`flex flex-row w-full h-[150px] min-[768px]:h-[110px] hover:bg-[#191E2B] active:bg-[#0046FA] ${cashGameSelected["type"] === "quick" ? 'bg-[#0046FA] hover:bg-[#0046FA]' : ''} rounded-[8px]`} onClick={() => {
            setCashGameSelected({
              type: "quick",
              url: "/quick-games/create/",
            });
          }}>
            <div className="h-full w-[120px] flex items-center justify-center">
              <QuickIcon />
            </div>
            <div className="h-full w-full flex flex-col justify-center pt-[16px] pb-[16px] pr-[20px]">
              <div className="text-[14px] text-white font-semibold min-[768px]:mb-[16px]">Quick Start</div>
              <div className="text-[14px] text-white font-normal">A quick start cash table is great for a casual game with friends, especially those who do not already have accounts. </div>
            </div>
          </div>

          <div className={`flex flex-row w-full h-[150px] min-[768px]:h-[110px] hover:bg-[#191E2B] active:bg-[#0046FA] ${cashGameSelected["type"] === "regular" ? 'bg-[#0046FA] hover:bg-[#0046FA]' : ''} rounded-[8px] rounded-[8px]`} onClick={() => {
            setCashGameSelected({
              type: "regular",
              url: "/cash-games/create",
            });
          }}>
            <div className="h-full w-[120px] flex items-center justify-center">
              <RegularIcon />
            </div>
            <div className="h-full w-full flex flex-col justify-center pt-[16px] pb-[16px] pr-[20px]">
              <div className="text-[14px] text-white font-semibold min-[768px]:mb-[16px]">Regular</div>
              <div className="text-[14px] text-white font-normal">A regular cash table is great for a semi-consistent home game or new group of friends made on the platform. This table type requires all players to have accounts</div>
            </div>
          </div>
        </div>
      </div>

      <div className="flex flex-col min-[500px]:flex-row items-center justify-center gap-3 max-w-[700px] w-full pb-[30px]">

        <div
          className="fixed top-[13px] left-[20px] bg-[#090b11] z-[100] min-[500px]:hidden
                            h-[32px] w-[26px] items-center flex justify-center text-white"
          onClick={() => {
            setShow(false);
            setCashGameSelected("");
          }}
        >
          <BackArrowHeaderIcon />
        </div>


        <Button
          key="Cancel"
          onClick={() => {
            setShow(false);
            setCashGameSelected("");
          }}
          className="!h-[40px] !w-full !max-w-[700px] max-[499px]:hidden !border-none"
          variant={'grayBorderButton'}
          id="Cancel"
        >
          <BackArrowIcon className="mr-[15px]" />
          Back
        </Button>
        <Button
          key="Continue"
          className="w-full !h-[40px] max-w-none"
          variant={'blueButton'}
          disabled={cashGameSelected === ""}
          onClick={() => handleContinueBtn()}
        >
          Continue
        </Button>
      </div>
    </div>
  );
}

const QuickIcon = () => {
  return (<svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M21.7393 11.7815C21.5892 11.6013 21.5844 11.341 21.7279 11.1555C22.484 10.1777 22.9509 9.00754 23.0755 7.77781C23.2002 6.54808 22.9776 5.30804 22.433 4.19843C21.8885 3.08883 21.0438 2.15411 19.9948 1.50037C18.9459 0.84668 17.7347 0.500114 16.4988 0.5L21.7393 11.7815ZM21.7393 11.7815C21.8895 11.9616 22.1447 12.0132 22.353 11.9055M21.7393 11.7815L22.353 11.9055M22.353 11.9055C23.4533 11.3367 24.6912 11.0884 25.9256 11.189C27.1601 11.2895 28.3415 11.7348 29.3352 12.4742C30.3289 13.2135 31.095 14.2171 31.546 15.3706C31.9971 16.5242 32.115 17.7812 31.8864 18.9985C31.6578 20.2158 31.0918 21.3444 30.253 22.2557C29.4142 23.167 28.3362 23.8243 27.142 24.1527C25.9478 24.4812 24.6853 24.4675 23.4984 24.1133C22.3116 23.7591 21.2481 23.0786 20.4292 22.1494C20.2917 21.9934 20.072 21.9388 19.8774 22.0123M22.353 11.9055L19.8774 22.0123M19.8774 22.0123C19.6828 22.0858 19.5541 22.272 19.5541 22.48M19.8774 22.0123L19.5541 22.48M19.5541 22.48V24.8889C19.5541 24.9298 19.5591 24.9705 19.569 25.0102M19.5541 22.48L19.569 25.0102M19.569 25.0102L20.9176 30.4047C21.0579 30.9658 20.6366 31.5 20.0767 31.5H12.9205C12.3605 31.5 11.9392 30.9658 12.0795 30.4047L13.4281 25.0102C13.438 24.9706 13.443 24.93 13.4431 24.8893M19.569 25.0102L13.4431 24.8893M13.4431 24.8893L13.4448 22.4804C13.445 22.2723 13.3163 22.086 13.1218 22.0123M13.4431 24.8893L13.1218 22.0123M13.1218 22.0123C12.9272 21.9387 12.7074 21.9933 12.5698 22.1493M13.1218 22.0123L12.5698 22.1493M12.5698 22.1493C11.7507 23.0783 10.6872 23.7585 9.50042 24.1124C8.31363 24.4664 7.05127 24.4798 5.85719 24.1513C4.66311 23.8227 3.58533 23.1654 2.74665 22.2541C1.90796 21.3428 1.34211 20.2143 1.11356 18.9971C0.885002 17.7799 1.00294 16.523 1.45394 15.3696C1.90493 14.2161 2.67084 13.2126 3.66441 12.4732C4.65797 11.7339 5.83922 11.2885 7.07358 11.1878C8.30793 11.0871 9.54575 11.3352 10.646 11.9038C10.8543 12.0114 11.1094 11.9598 11.2596 11.7797M12.5698 22.1493L11.2596 11.7797M11.2596 11.7797C11.4097 11.5996 11.4145 11.3393 11.2712 11.1538M11.2596 11.7797L11.2712 11.1538M11.2712 11.1538C10.5156 10.1761 10.0491 9.0063 9.92468 7.77698M11.2712 11.1538L9.92468 7.77698M9.92468 7.77698C9.80023 6.54766 10.0228 5.30806 10.5671 4.19881M9.92468 7.77698L10.5671 4.19881M10.5671 4.19881C11.1114 3.08955 11.9556 2.15503 13.0041 1.50125M10.5671 4.19881L13.0041 1.50125M13.0041 1.50125C14.0525 0.847526 15.2631 0.500662 16.4985 0.5L13.0041 1.50125Z" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
  );
}

const RegularIcon = () => {
  return (<svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M23.8846 25.5742L23.8837 25.5742C22.5735 25.5765 21.2834 25.2693 20.1268 24.6805L19.0247 24.1194L19.4272 25.2888L21.258 30.6072L21.2579 30.6072L21.2604 30.6141C21.2959 30.7126 21.3058 30.8174 21.2896 30.9196C21.2733 31.022 21.2312 31.1205 21.1652 31.2063L21.1651 31.2063L21.1603 31.2127C21.096 31.2992 21.01 31.3714 20.9081 31.422C20.8063 31.4726 20.6925 31.4996 20.5761 31.5C20.5759 31.5 20.5757 31.5 20.5755 31.5H12.4245C12.4243 31.5 12.4241 31.5 12.4239 31.5C12.3075 31.4996 12.1937 31.4726 12.0919 31.422C11.99 31.3714 11.904 31.2992 11.8397 31.2127L11.8397 31.2127L11.8348 31.2063C11.7688 31.1205 11.7267 31.022 11.7104 30.9196C11.6942 30.8174 11.7041 30.7126 11.7396 30.6141L11.7396 30.6141L11.742 30.6072L13.5728 25.2888L13.9753 24.1194L12.8732 24.6805C11.7166 25.2693 10.4265 25.5765 9.11626 25.5742H9.11538C6.95709 25.5742 4.89081 24.7484 3.3702 23.2842C1.85024 21.8206 1 19.8396 1 17.7781C1 15.9439 1.87241 13.9737 3.26615 12.01C4.65418 10.0544 6.5216 8.15784 8.42473 6.4814C12.1059 3.2387 15.8637 0.868709 16.3876 0.538309C16.3987 0.53126 16.4084 0.52514 16.4166 0.51996C16.4412 0.507253 16.4699 0.5 16.5 0.5C16.5301 0.5 16.5588 0.507252 16.5834 0.519959C16.5916 0.525139 16.6013 0.53126 16.6124 0.538309C17.1363 0.868709 20.8941 3.2387 24.5753 6.4814C26.4784 8.15784 28.3458 10.0544 29.7338 12.01C31.1276 13.9737 32 15.9439 32 17.7781C32 19.8396 31.1498 21.8206 29.6298 23.2842C28.1092 24.7484 26.0429 25.5742 23.8846 25.5742ZM11.4385 31.5111L11.4385 31.5111L11.4385 31.5111Z" stroke="white" />
  </svg>);
}

export const BackArrowIcon = ({ className = '' }) => {
  return (
    <svg className={className} width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.06253 14.2552C8.33551 14.5659 8.30531 15.0391 7.99503 15.3127C7.68423 15.5856 7.2111 15.5554 6.93753 15.2452L0.937527 8.49515C0.688793 8.21202 0.688793 7.78828 0.937527 7.50515L6.93753 0.755148C7.1105 0.540392 7.38737 0.437877 7.65849 0.4882C7.92962 0.538523 8.15126 0.733567 8.23564 0.996092C8.32003 1.25862 8.25355 1.54627 8.06253 1.74515L2.50503 8.00015L8.06253 14.2552Z" fill="white" />
    </svg>
  );
}

export const BackArrowHeaderIcon = ({ className = '' }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M16.7502 20.34C17.1142 20.7544 17.0739 21.3853 16.6602 21.75C16.2458 22.114 15.615 22.0737 15.2502 21.66L7.2502 12.66C6.91855 12.2825 6.91855 11.7175 7.2502 11.34L15.2502 2.34003C15.4808 2.05369 15.85 1.91701 16.2115 1.9841C16.573 2.0512 16.8685 2.31126 16.981 2.66129C17.0935 3.01132 17.0049 3.39487 16.7502 3.66003L9.3402 12L16.7502 20.34Z" fill="white" />
    </svg>
  );
}
